import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  subRowText: {
    fontSize: '12px',
    marginTop: theme.spacing(0.75),
    fontWeight: 400,
    color: theme.palette.labraText.description,
  },
}))
